// extracted by mini-css-extract-plugin
export default {"container":"AvoidScam_container__XFEhw","heading":"AvoidScam_heading__jtlEY","content":"AvoidScam_content__uScpa"};